module.exports = {"440904001":"南海街道","440904002":"高地街道","440904003":"水东街道","440904004":"电海街道","440904005":"陈村街道","440904100":"马踏镇","440904101":"岭门镇","440904102":"坡心镇","440904103":"七迳镇","440904104":"树仔镇","440904105":"沙院镇","440904106":"麻岗镇","440904107":"旦场镇","440904109":"小良镇","440904115":"霞洞镇","440904116":"观珠镇","440904117":"沙琅镇","440904118":"黄岭镇","440904119":"望夫镇","440904120":"罗坑镇","440904121":"那霍镇","440904125":"博贺镇","440904126":"林头镇","440904127":"电城镇","440904451":"曙光农场","440904452":"水丰农场","440904453":"新华农场","440904454":"电白盐场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440904.json
// module id = 2133
// module chunks = 0